<template>
  <el-button
    :type="type"
    :size="size"
    :icon="icon"
    :loading="loading"
    :plain="plain"
    @click="handleExport"
  >
    {{ text || '导出数据' }}
  </el-button>
</template>

<script>
export default {
  name: 'ExportButton',
  props: {
    // 导出API调用函数
    apiCall: {
      type: Function,
      required: true
    },
    // 导出参数
    params: {
      type: Object,
      default: () => ({})
    },
    // 参数处理策略
    // 可选值：'none' - 不处理, 'copy' - 浅拷贝, 'deep' - 深拷贝, 'function' - 使用处理函数
    // paramsStrategy: {
    //   type: String,
    //   default: 'function',
    //   validator: value => ['none', 'copy', 'deep', 'function'].includes(value)
    // },
    // 参数处理函数
    paramsProcessor: {
      type: Function,
      default: null
    },
    // 按钮形式
    plain: {
      type: Boolean,
      default: true
    },
    // 按钮类型
    type: {
      type: String,
      default: 'success'
    },
    // 按钮大小
    size: {
      type: String,
      default: 'medium'
    },
    // 按钮图标
    icon: {
      type: String,
      default: 'el-icon-download'
    },
    // 按钮文本
    text: {
      type: String,
      default: '导出'
    },
    // 成功提示消息
    successMessage: {
      type: String,
      default: '导出任务已提交，任务完成后将自动下载'
    },
    // 加载提示文本
    loadingText: {
      type: String,
      default: '正在提交导出任务...'
    },
    // 错误提示消息
    errorMessage: {
      type: String,
      default: '导出任务提交失败'
    },
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    // 处理参数
    processParams(params) {
      if (this.paramsProcessor && typeof this.paramsProcessor === 'function') {
        return this.paramsProcessor(params);
      }
      return JSON.parse(JSON.stringify(params));
    },
    
    // 执行导出
    async executeExport() {
      if (this.loading) return;
      
      try {
        this.loading = true;
        
        // 处理参数
        const processedParams = this.processParams(this.params);
        
        // 创建API调用函数
        const apiCallWithParams = () => this.apiCall(processedParams);
        
        // 使用全局导出方法
        const result = await this.$exportData(apiCallWithParams, {
          successMessage: this.successMessage,
          loadingText: this.loadingText,
          errorMessage: this.errorMessage,
          showLoading: false // 由组件自己控制loading状态
        });
        
        // 触发事件
        this.$emit('export-submitted', {
          success: result.success,
          taskId: result.taskId,
          params: processedParams
        });
        
        return result;
      } catch (error) {
        console.error('导出操作失败:', error);
        this.$message.error(this.errorMessage);
        
        // 触发事件
        this.$emit('export-error', error);
        throw error;
      } finally {
        this.loading = false;
      }
    },
    
    // 处理导出点击
    handleExport() {
      // 显示确认对话框
      const h = this.$createElement;
      this.$confirm(
        h('p', null, [
          h('span', null, '您确定要导出该模块的数据吗？确认后可在 '),
          h('span', { style: 'color: teal' }, '【功能模块-导出管理】'),
          h('span', null, '中查看导出状态 '),
        ]),
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          customClass: 'export-confirm-dialog-q8d8e8a9',
        }
      ).then(() => {
        this.executeExport();
      }).catch(() => {
        // 用户取消，不做任何处理
      });
    }
  }
};
</script>

<style scoped lang="scss">
// 组件样式

</style>

<style lang="scss">
// 全局样式
// 注意：Element UI 的弹窗样式需要放在全局样式中，不能使用 scoped
// 避免污染全局样式，加个标识
.export-confirm-dialog-q8d8e8a9 {
  width: 342px !important;
}
</style>